import { render } from "./Cart.vue?vue&type=template&id=3c004636"
import script from "./Cart.vue?vue&type=script&lang=js"
export * from "./Cart.vue?vue&type=script&lang=js"

import "./Cart.vue?vue&type=style&index=0&id=3c004636&lang=less"
script.render = render

export default script